export const GasStation = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 27H21" stroke="currentColor" stroke-width="2"/>
<path d="M18 27V5H5V27" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 11H15" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M18 16H23V25C23 26.3807 24.1193 27.5 25.5 27.5V27.5C26.8807 27.5 28 26.3807 28 25V9.41421C28 9.149 27.8946 8.89464 27.7071 8.70711L22.5 3.5" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M28 14H27C26.4477 14 26 13.5523 26 13V7" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
